"use client";
import * as React from "react";
const SvgBuildOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M15.78 13.087 9.15 6.479A4.723 4.723 0 0 0 8.1 1.384 4.758 4.758 0 0 0 1.943.911l2.804 2.802L3.71 4.739.914 1.952a4.71 4.71 0 0 0 .475 6.128 4.76 4.76 0 0 0 5.03 1.077l6.653 6.63a.729.729 0 0 0 1.03 0l1.679-1.674a.71.71 0 0 0 0-1.026Zm-2.19 1.165L6.683 7.367a3.198 3.198 0 0 1-1.46.596A3.272 3.272 0 0 1 1.461 4.55l2.256 2.249 3.096-3.086-2.256-2.249c.905-.05 1.818.27 2.512.954A3.245 3.245 0 0 1 7.975 5.3a3.16 3.16 0 0 1-.643 1.426l6.9 6.878-.642.648Z" }));
export {
  SvgBuildOutlined as default
};
